import React, { createContext, useContext, useState, useCallback } from "react";
import { PublicAuthOverlay } from "@/components/public/PublicAuthOverlay";

interface PublicAuthContextType {
  /** Call this to show the auth overlay. Use as onClick handler for any interactive element in public view. */
  requireAuth: () => void;
  isPublicView: boolean;
}

const PublicAuthContext = createContext<PublicAuthContextType>({
  requireAuth: () => {},
  isPublicView: false,
});

export const usePublicAuth = () => useContext(PublicAuthContext);

interface PublicAuthProviderProps {
  children: React.ReactNode;
  isPublicView: boolean;
}

export const PublicAuthProvider: React.FC<PublicAuthProviderProps> = ({ children, isPublicView }) => {
  const [showOverlay, setShowOverlay] = useState(false);

  const requireAuth = useCallback(() => {
    if (isPublicView) {
      setShowOverlay(true);
    }
  }, [isPublicView]);

  return (
    <PublicAuthContext.Provider value={{ requireAuth, isPublicView }}>
      {children}
      {showOverlay && <PublicAuthOverlay onDismiss={() => setShowOverlay(false)} />}
    </PublicAuthContext.Provider>
  );
};
